export const SIZE = {
  250: 'thumb',
  600: 'medium',
}

export const DATE_TYPES = {
  TODAY: 'today',
  WEEKDAY: 'week',
  MONTH: 'month',
  LAST_MONTH: 'last_month',
  YEAR: 'year',
  ALL: 'all',
  YESTERDAY: 'yesterday',
}
export const PROJECT_STATUS = {
  PROJECT_WAIT: 1,
  PROJECT_NOT_VALID: 2,
  PROJECT_APPROVE_WAIT: 3,
  PROJECT_PLAN: 4,
  PROJECT_NOT_APPROVE: 5,
  PROJECT_IN_PROGRESS: 6,
  PROJECT_WAIT_REVIEW: 7,
  PROJECT_COMPLETE: 8,
  PROJECT_CANCEL: 9,
  PROJECT_COMPLETED_WITH_QR: 10,
  PROJECT_REJECT: 11,
}

export const PROJECT_STATUS_TEXT = {
  PROJECT_WAIT: "Chờ xử lý",
  PROJECT_NOT_VALID: "Không phù hợp",
  PROJECT_APPROVE_WAIT: "Lập kế hoạch",
  PROJECT_PLAN: "Chờ phê duyệt kế hoạch",
  PROJECT_NOT_APPROVE: "Không phê duyệt kế hoạch",
  PROJECT_IN_PROGRESS: "Đang thực hiện",
  PROJECT_WAIT_REVIEW: "Chờ duyệt",
  PROJECT_COMPLETE: "Đã duyệt",
  PROJECT_CANCEL: "Hủy",
  PROJECT_COMPLETED_WITH_QR: "Hoàn thành hồ sơ",
  PROJECT_REJECT_TEXT: "Từ chối duyệt",


}

export const PROJECT_MEMBER_STATUS = {
  PENDING: 0,
  CONFIRM_STATUS_CONFIRMED: 1,
  CONFIRM_STATUS_LEADER_APPROVED: 2,
}

export const PROJECT_MEMBER_STATUS_TEXT = {
  PENDING: "Đang Thực Hiện",
  CONFIRM_STATUS_CONFIRMED: "Chờ duyệt",
  CONFIRM_STATUS_LEADER_APPROVED: "Hoàn thành",
}

export const MEMBER_STATUS_OPTIONS = [
  {
    label: PROJECT_MEMBER_STATUS_TEXT.CONFIRM_STATUS_CONFIRMED,
    value: PROJECT_MEMBER_STATUS.CONFIRM_STATUS_CONFIRMED,
    color: "warning",
  },
  {
    label: PROJECT_MEMBER_STATUS_TEXT.CONFIRM_STATUS_LEADER_APPROVED,
    value: PROJECT_MEMBER_STATUS.CONFIRM_STATUS_LEADER_APPROVED,
    color: "success",
  },
  {
    label: PROJECT_MEMBER_STATUS_TEXT.PENDING,
    value: PROJECT_MEMBER_STATUS.PENDING,
    color: "primary",
  },
]

export const PROJECT_MEMBER_STATUS_APPROVED = {
  PENDING: 0,
  REJECTED: 1,
  APPROVED: 2,
}

export const PROJECT_MEMBER_STATUS_APPROVED_TEXT = {
  PENDING: "Chưa duyệt",
  REJECTED: "Từ chối duyệt",
  APPROVED: "Đã duyệt",
}

export const MEMBER_STATUS_APPROVED_OPTIONS = [
  {
    label: PROJECT_MEMBER_STATUS_APPROVED_TEXT.PENDING,
    value: PROJECT_MEMBER_STATUS_APPROVED.PENDING,
    color: "warning",
  },
  {
    label: PROJECT_MEMBER_STATUS_APPROVED_TEXT.REJECTED,
    value: PROJECT_MEMBER_STATUS_APPROVED.REJECTED,
    color: "error",
  },
  {
    label: PROJECT_MEMBER_STATUS_APPROVED_TEXT.APPROVED,
    value: PROJECT_MEMBER_STATUS_APPROVED.APPROVED,
    color: "success",
  },
]

export const PROJECT_STATUS_OPTIONS = [
  {
    label: PROJECT_STATUS_TEXT.PROJECT_APPROVE_WAIT,
    value: PROJECT_STATUS.PROJECT_APPROVE_WAIT,
    color: "warning",
  },
  {
    label: PROJECT_STATUS_TEXT.PROJECT_IN_PROGRESS,
    value: PROJECT_STATUS.PROJECT_IN_PROGRESS,
    color: "primary",
  },
  {
    label: PROJECT_STATUS_TEXT.PROJECT_WAIT_REVIEW,
    value: PROJECT_STATUS.PROJECT_WAIT_REVIEW,
    color: "warning",
  },
  {
    label: PROJECT_STATUS_TEXT.PROJECT_COMPLETE,
    value: PROJECT_STATUS.PROJECT_COMPLETE,
    color: "success",
  },
  {
    label: PROJECT_STATUS_TEXT.PROJECT_CANCEL,
    value: PROJECT_STATUS.PROJECT_CANCEL,
    color: "default",
  },
  {
    label: PROJECT_STATUS_TEXT.PROJECT_COMPLETED_WITH_QR,
    value: PROJECT_STATUS.PROJECT_COMPLETED_WITH_QR,
    color: "success",
  },
  {
    label: PROJECT_STATUS_TEXT.PROJECT_REJECT_TEXT,
    value: PROJECT_STATUS.PROJECT_REJECT,
    color: "error",
  },
]

export const LOOP_TYPE = {
  LOOP_TYPE_SHIFT: 1,
  LOOP_TYPE_MANUAL: 2,
  LOOP_TYPE_MEASURE: 3,
}

export const LOOP_TYPE_NAME = {
  LOOP_TYPE_SHIFT: "Theo ca làm việc",
  LOOP_TYPE_MANUAL: "Thủ công bằng tay",
  LOOP_TYPE_MEASURE: "Theo số liệu",
}

export const LOOP_TYPE_OPTIONS = [
  {
    id: LOOP_TYPE.LOOP_TYPE_MANUAL,
    value: LOOP_TYPE_NAME.LOOP_TYPE_MANUAL,
  },
  {
    id: LOOP_TYPE.LOOP_TYPE_SHIFT,
    value: LOOP_TYPE_NAME.LOOP_TYPE_SHIFT,
  },
  {
    id: LOOP_TYPE.LOOP_TYPE_MEASURE,
    value: LOOP_TYPE_NAME.LOOP_TYPE_MEASURE,
  },
]

export const SUBCONTRACT_STATUS = {
  SUBCONTRACT_ACTIVE: 1,
  SUBCONTRACT_INACTIVE: 2,
}

export const SUBCONTRACT_STATUS_TEXT = {
  SUBCONTRACT_ACTIVE: "Đang hoạt động",
  SUBCONTRACT_INACTIVE: "Dừng hoạt động",
}

export const SUBCONTRACT_OPTIONS = [
  {
    id: SUBCONTRACT_STATUS.SUBCONTRACT_ACTIVE,
    value: SUBCONTRACT_STATUS_TEXT.SUBCONTRACT_ACTIVE,
  },
  {
    id: SUBCONTRACT_STATUS.SUBCONTRACT_INACTIVE,
    value: SUBCONTRACT_STATUS_TEXT.SUBCONTRACT_INACTIVE,
  },
]

export const TYPE_99_FUNCTION = {
  TYPE_99_PROJECT_ORDER_CODE: 'ptp_getProjectOrderCode',
  TYPE_99_CUSTOMER_NAME: 'ptp_getCustomerName',
  TYPE_99_CUSTOMER_ADDRESS: 'ptp_getCustomerAddress',
  TYPE_99_CERTIFICATE_DATE: 'ptp_getCertificateDate',
  TYPE_99_CONTRACT_DATE: 'ptp_getContractDate',
  TYPE_99_CONTRACT_NUMBER: 'ptp_getContractNumber',
  TYPE_99_REQUEST_DATE: 'ptp_getRequestDate',
  TYPE_99_PROJECT_GOODS: 'ptp_getProjectGoods',
  TYPE_99_PROJECT_GOODS_AMOUNT: 'ptp_getProjectGoodsAmount',
  TYPE_99_PROJECT_INSPECTION_TYPE: 'ptp_getProjectInspectionType',
  TYPE_99_CURRENT_DAY: 'ptp_currentDay',
  TYPE_99_CURRENT_MONTH: 'ptp_currentMonth',
  TYPE_99_CURRENT_YEAR: 'ptp_currentYear',
  TYPE_99_CURRENT_DATE: 'ptp_currentDate',
  TYPE_99_CURRENT_HOUR: 'ptp_currentHour',
  TYPE_99_CREATOR_NAME: 'ptp_creatorName',
  TYPE_99_CREATOR_CODE: 'ptp_creatorCode',
  TYPE_99_CONTACT_INFO: 'ptp_getContactInfo',
  TYPE_99_NGAY_CAP_CHUNG_THU: 'ptp_getDateOfIssue',
  TYPE_99_TEN_DON_VI: 'ptp_getDepartmentName',
}

export const TYPE_99_FUNCTION_TEXT = {
  TYPE_99_PROJECT_ORDER_CODE: 'Mã vụ giám định',
  TYPE_99_CUSTOMER_NAME: 'Tên công ty khách hàng',
  TYPE_99_CUSTOMER_ADDRESS: 'Địa chỉ công ty khách hàng',
  TYPE_99_CERTIFICATE_DATE: 'Ngày dự kiến hoàn thành',
  TYPE_99_CONTRACT_DATE: 'Ngày hợp đồng',
  TYPE_99_CONTRACT_NUMBER: 'Số hợp đồng',
  TYPE_99_REQUEST_DATE: 'Ngày yêu cầu',
  TYPE_99_PROJECT_GOODS: 'Mặt hàng',
  TYPE_99_PROJECT_GOODS_AMOUNT: 'Số khối',
  TYPE_99_PROJECT_INSPECTION_TYPE: 'Loại hình giám định',
  TYPE_99_CURRENT_DAY: 'Ngày hiện tại',
  TYPE_99_CURRENT_MONTH: 'Tháng hiện tại',
  TYPE_99_CURRENT_YEAR: 'Năm hiện tại',
  TYPE_99_CURRENT_DATE: 'Ngày tháng năm hiện tại',
  TYPE_99_CURRENT_HOUR: 'Ngày tháng năm với giờ hiện tại',
  TYPE_99_CREATOR_NAME: 'Tên người tạo biểu',
  TYPE_99_CREATOR_CODE: 'Mã người tạo biểu',
  TYPE_99_CONTACT_INFO: 'Thông tin liên hệ trên biểu',
  TYPE_99_NGAY_CAP_CHUNG_THU: 'Ngày cấp chứng thư (ngày trưởng phòng duyệt)',
  TYPE_99_TEN_DON_VI: 'Tên đơn vị thực hiện',
}

export const TYPE_99_FUNCTION_OPTIONS = [
  {
    id: TYPE_99_FUNCTION.TYPE_99_PROJECT_ORDER_CODE,
    value: TYPE_99_FUNCTION_TEXT.TYPE_99_PROJECT_ORDER_CODE,
  },
  {
    id: TYPE_99_FUNCTION.TYPE_99_CUSTOMER_NAME,
    value: TYPE_99_FUNCTION_TEXT.TYPE_99_CUSTOMER_NAME,
  },
  {
    id: TYPE_99_FUNCTION.TYPE_99_CUSTOMER_ADDRESS,
    value: TYPE_99_FUNCTION_TEXT.TYPE_99_CUSTOMER_ADDRESS,
  },
  {
    id: TYPE_99_FUNCTION.TYPE_99_CERTIFICATE_DATE,
    value: TYPE_99_FUNCTION_TEXT.TYPE_99_CERTIFICATE_DATE,
  },
  {
    id: TYPE_99_FUNCTION.TYPE_99_CONTRACT_DATE,
    value: TYPE_99_FUNCTION_TEXT.TYPE_99_CONTRACT_DATE,
  },
  {
    id: TYPE_99_FUNCTION.TYPE_99_CONTRACT_NUMBER,
    value: TYPE_99_FUNCTION_TEXT.TYPE_99_CONTRACT_NUMBER,
  },
  {
    id: TYPE_99_FUNCTION.TYPE_99_REQUEST_DATE,
    value: TYPE_99_FUNCTION_TEXT.TYPE_99_REQUEST_DATE,
  },
  {
    id: TYPE_99_FUNCTION.TYPE_99_PROJECT_GOODS,
    value: TYPE_99_FUNCTION_TEXT.TYPE_99_PROJECT_GOODS,
  },
  {
    id: TYPE_99_FUNCTION.TYPE_99_PROJECT_GOODS_AMOUNT,
    value: TYPE_99_FUNCTION_TEXT.TYPE_99_PROJECT_GOODS_AMOUNT,
  },
  {
    id: TYPE_99_FUNCTION.TYPE_99_PROJECT_INSPECTION_TYPE,
    value: TYPE_99_FUNCTION_TEXT.TYPE_99_PROJECT_INSPECTION_TYPE,
  },
  {
    id: TYPE_99_FUNCTION.TYPE_99_CURRENT_DAY,
    value: TYPE_99_FUNCTION_TEXT.TYPE_99_CURRENT_DAY,
  },
  {
    id: TYPE_99_FUNCTION.TYPE_99_CURRENT_MONTH,
    value: TYPE_99_FUNCTION_TEXT.TYPE_99_CURRENT_MONTH,
  },
  {
    id: TYPE_99_FUNCTION.TYPE_99_CURRENT_YEAR,
    value: TYPE_99_FUNCTION_TEXT.TYPE_99_CURRENT_YEAR,
  },
  {
    id: TYPE_99_FUNCTION.TYPE_99_CURRENT_DATE,
    value: TYPE_99_FUNCTION_TEXT.TYPE_99_CURRENT_DATE,
  },
  {
    id: TYPE_99_FUNCTION.TYPE_99_CURRENT_HOUR,
    value: TYPE_99_FUNCTION_TEXT.TYPE_99_CURRENT_HOUR,
  },
  {
    id: TYPE_99_FUNCTION.TYPE_99_CREATOR_NAME,
    value: TYPE_99_FUNCTION_TEXT.TYPE_99_CREATOR_NAME,
  },
  {
    id: TYPE_99_FUNCTION.TYPE_99_CREATOR_CODE,
    value: TYPE_99_FUNCTION_TEXT.TYPE_99_CREATOR_CODE,
  },
  {
    id: TYPE_99_FUNCTION.TYPE_99_CONTACT_INFO,
    value: TYPE_99_FUNCTION_TEXT.TYPE_99_CONTACT_INFO,
  },
  {
    id: TYPE_99_FUNCTION.TYPE_99_NGAY_CAP_CHUNG_THU,
    value: TYPE_99_FUNCTION_TEXT.TYPE_99_NGAY_CAP_CHUNG_THU,
  },
  {
    id: TYPE_99_FUNCTION.TYPE_99_TEN_DON_VI,
    value: TYPE_99_FUNCTION_TEXT.TYPE_99_TEN_DON_VI,
  },
]

export const TEMPLATE_PARAM_TYPE = {
  TYPE_SELF_INPUT: 1,
  TYPE_OPTIONS_IN_LIST: 2,
  TYPE_IMAGE_SIGN: 3,
  TYPE_IMAGE_SIGN_OF_CUSTOMER: 4,
  TYPE_NUMBER: 5,
  TYPE_NAME_OF_ASSESSOR: 6,
  TYPE_MEASUREMENT_NAME: 95,
  TYPE_LABEL_VALUE: 96,
  TYPE_PARAM_VALUE: 97,
  TYPE_RECIPE: 98,
  TYPE_FIXED_DATA: 99,
  TYPE_EXECUTION_STEP: 100,
  TYPE_ACTION_CONCLUSIONS: 101,
  TYPE_WORK_SESSION_NAME: 102,
  TYPE_STAFF: 103,
  TYPE_CERTIFICATE_SERIAL_NUMBER: 104,
}

export const TEMPLATE_PARAM_NAME = {
  TYPE_SELF_INPUT: "Tự nhập",
  TYPE_OPTIONS_IN_LIST: "Lựa chọn từ danh sách",
  TYPE_IMAGE_SIGN: "Ảnh chữ kí",
  TYPE_IMAGE_SIGN_OF_CUSTOMER: "Ảnh chữ kí của khách hàng",
  TYPE_NUMBER: "Số thứ tự",
  TYPE_NAME_OF_ASSESSOR: "Tên giám định viên",
  TYPE_MEASUREMENT_NAME: "Độ đo - Tên lần đo",
  TYPE_LABEL_VALUE: "Độ đo - Giá trị nhãn",
  TYPE_PARAM_VALUE: "Độ đo - Giá trị tham số",
  TYPE_RECIPE: "Độ đo - Công thức",
  TYPE_FIXED_DATA: "Lấy dữ liệu cố định",
  TYPE_EXECUTION_STEP: "Lấy dữ liệu theo bước thực hiện",
  TYPE_ACTION_CONCLUSIONS: "Lấy kết luận hành động",
  TYPE_WORK_SESSION_NAME: "Tên công việc (ca làm việc)",
  TYPE_STAFF: "Lấy từ danh sách nhân sự",
  TYPE_CERTIFICATE_SERIAL_NUMBER: "Số chứng thư",
}

export const TEMPLATE_PARAM_OPTIONS = [
  {
    id: TEMPLATE_PARAM_TYPE.TYPE_SELF_INPUT,
    value: TEMPLATE_PARAM_NAME.TYPE_SELF_INPUT,
  },
  {
    id: TEMPLATE_PARAM_TYPE.TYPE_OPTIONS_IN_LIST,
    value: TEMPLATE_PARAM_NAME.TYPE_OPTIONS_IN_LIST,
  },
  {
    id: TEMPLATE_PARAM_TYPE.TYPE_IMAGE_SIGN,
    value: TEMPLATE_PARAM_NAME.TYPE_IMAGE_SIGN,
  },
  {
    id: TEMPLATE_PARAM_TYPE.TYPE_IMAGE_SIGN_OF_CUSTOMER,
    value: TEMPLATE_PARAM_NAME.TYPE_IMAGE_SIGN_OF_CUSTOMER,
  },
  {
    id: TEMPLATE_PARAM_TYPE.TYPE_NUMBER,
    value: TEMPLATE_PARAM_NAME.TYPE_NUMBER,
  },
  {
    id: TEMPLATE_PARAM_TYPE.TYPE_NAME_OF_ASSESSOR,
    value: TEMPLATE_PARAM_NAME.TYPE_NAME_OF_ASSESSOR,
  },
  {
    id: TEMPLATE_PARAM_TYPE.TYPE_MEASUREMENT_NAME,
    value: TEMPLATE_PARAM_NAME.TYPE_MEASUREMENT_NAME,
  },
  {
    id: TEMPLATE_PARAM_TYPE.TYPE_LABEL_VALUE,
    value: TEMPLATE_PARAM_NAME.TYPE_LABEL_VALUE,
  },
  {
    id: TEMPLATE_PARAM_TYPE.TYPE_PARAM_VALUE,
    value: TEMPLATE_PARAM_NAME.TYPE_PARAM_VALUE,
  },
  {
    id: TEMPLATE_PARAM_TYPE.TYPE_RECIPE,
    value: TEMPLATE_PARAM_NAME.TYPE_RECIPE,
  },
  {
    id: TEMPLATE_PARAM_TYPE.TYPE_FIXED_DATA,
    value: TEMPLATE_PARAM_NAME.TYPE_FIXED_DATA,
  },
  {
    id: TEMPLATE_PARAM_TYPE.TYPE_EXECUTION_STEP,
    value: TEMPLATE_PARAM_NAME.TYPE_EXECUTION_STEP,
  },
  {
    id: TEMPLATE_PARAM_TYPE.TYPE_ACTION_CONCLUSIONS,
    value: TEMPLATE_PARAM_NAME.TYPE_ACTION_CONCLUSIONS,
  },
  {
    id: TEMPLATE_PARAM_TYPE.TYPE_WORK_SESSION_NAME,
    value: TEMPLATE_PARAM_NAME.TYPE_WORK_SESSION_NAME,
  },
  {
    id: TEMPLATE_PARAM_TYPE.TYPE_STAFF,
    value: TEMPLATE_PARAM_NAME.TYPE_STAFF,
  },
  {
    id: TEMPLATE_PARAM_TYPE.TYPE_CERTIFICATE_SERIAL_NUMBER,
    value: TEMPLATE_PARAM_NAME.TYPE_CERTIFICATE_SERIAL_NUMBER,
  },
]

export const NOTIFICATION_FLAG = {
  READ: 1,
  UNREAD: 0,
}

export const SET_UP_TYPE = {
  USER_TYPE: 1,
  DEPARTMENT: 2,
}

export const SET_UP_NAME = {
  USER_TYPE: "Người Dùng",
  DEPARTMENT: "Phòng Ban",
}

export const CHECK_LIST_SET_UP_PUBLIC_DOCMENT = [
  {
    desc: 'Cấu hình cho các nhân viên',
    title: SET_UP_NAME.USER_TYPE,
    value: SET_UP_TYPE.USER_TYPE,
  },
  {
    desc: 'Cấu hình cho tập thể phòng ban',
    title: SET_UP_NAME.DEPARTMENT,
    value: SET_UP_TYPE.DEPARTMENT,
  },
]


export const DEVICE_STATUS = {
  DEVICE_NEW: 1,
  DEVICE_IN_USE: 2,
  DEVICE_IN_BROKEN: 3,
  DEVICE_NEED_MAINTENANCE: 4,
}

export const DEVICE_STATUS_TEXT = {
  DEVICE_NEW: "Mới",
  DEVICE_IN_USE: "Đang sử dụng",
  DEVICE_IN_BROKEN: "Hỏng",
  DEVICE_NEED_MAINTENANCE: "Cần bảo trì",
}

export const DEVICE_STATUS_OPTIONS = [
  {
    id: DEVICE_STATUS.DEVICE_NEW,
    value: DEVICE_STATUS_TEXT.DEVICE_NEW,
  },
  {
    id: DEVICE_STATUS.DEVICE_IN_USE,
    value: DEVICE_STATUS_TEXT.DEVICE_IN_USE,
  },
  {
    id: DEVICE_STATUS.DEVICE_IN_BROKEN,
    value: DEVICE_STATUS_TEXT.DEVICE_IN_BROKEN,
  },
  {
    id: DEVICE_STATUS.DEVICE_NEED_MAINTENANCE,
    value: DEVICE_STATUS_TEXT.DEVICE_NEED_MAINTENANCE,
  },
]

export const RISK = {
  GREEN: 1,
  YELLOW: 2,
  RED: 3,
}

export const RISK_TEXT = {
  GREEN: "Xanh",
  YELLOW: "Vàng",
  RED: "Đỏ",
}


export const RISK_OPTIONS = [
  {
    title: RISK_TEXT.GREEN,
    value: RISK.GREEN,
  },
  {
    title: RISK_TEXT.YELLOW,
    value: RISK.YELLOW,
  },
  {
    title: RISK_TEXT.RED,
    value: RISK.RED,
  },
]

export const DOCUMENT_TYPE = {
  DOCUMENT: -2,
  TEST_RESULTS: -1,
}

export const PROCESS_TYPE = {
  ACTION: 2,
  STEP: 1,
}

export const PROCESS_IMAGE_TYPE = {
  IMAGE: 'image',
  VIDEO: 'video',
	PHOTO: 'photo',
}

export const PROJECT_CHECKLIST_STATUS = {
  OK: 1,
  NG: 2,
}

export const NAME_MODULE_COMMON_DOCUMENT = {
  SUBCONTRACT: "subcontract",
}

export const TYPE_IN_MODULE_COMMON_DOCUMENT = {
  FILES_OF_SUBCONTRACT: 1, // File dính kèm của nhà thầu
}


export const PROJECT_ROLE = {
  STAFF: 1,
  LEADER: 2,
  SUPERVISOR: 3,
  RISK_LEVEL1: 3,
  TECHNICAL_CONTROLLER: 4,
  RISK_LEVEL2: 4,
  ASSESSMENT: 5,

}

export const PROJECT_ROLE_TEXT = {
  STAFF: "Nhân viên",
  LEADER: "Trưởng nhóm",
  SUPERVISOR: "Kiểm soát viên",
  TECHNICAL_CONTROLLER: "Kiểm soát kỹ thuật",
  ASSESSMENT: "Thẩm xét",
}

export const PROJECT_ROLE_OPTIONS = [
  {
    label: PROJECT_ROLE_TEXT.STAFF,
    value: PROJECT_ROLE.STAFF,
    color: "secondary",
  },
  {
    label: PROJECT_ROLE_TEXT.LEADER,
    value: PROJECT_ROLE.LEADER,
    color: "primary",
  },
  {
    label: PROJECT_ROLE_TEXT.SUPERVISOR,
    value: PROJECT_ROLE.SUPERVISOR,
    color: "warning",
  },
  {
    label: PROJECT_ROLE_TEXT.TECHNICAL_CONTROLLER,
    value: PROJECT_ROLE.TECHNICAL_CONTROLLER,
    color: "error",
  },
  {
    label: PROJECT_ROLE_TEXT.ASSESSMENT,
    value: PROJECT_ROLE.ASSESSMENT,
    color: "info",
  },
]


export const STAFF_ROLES = {
  SUPERADMIN: -1,
  DEPARTMENT_HEAD: 1,
  STAFF: 2,
  DEPUTY_HEAD: 3,
  DIRECTOR: 4,
  PROFILE_MANAGER: 5,
  INTERN: 6,
}

export const STAFF_ROLE_TEXT = {
  SUPERADMIN: "Quản trị viên",
  DEPARTMENT_HEAD: "Trưởng phòng",
  STAFF: "Nhân viên",
  DEPUTY_HEAD: "Phó phòng",
  DIRECTOR: "Giám đốc",
  PROFILE_MANAGER: "Quản lý hồ sơ",
  INTERN: "Giám định viên thực tập",

}
export const STAFF_ROLE_PROJECT = {
  DEPARTMENT_HEAD: 1,
  DEPUTY_HEAD: 2,
  LEADER: 3,
  STAFF: 4,
}
export const STAFF_ROLE_PROJECT_TEXT = {
  DEPARTMENT_HEAD: "Trưởng phòng",
  DEPUTY_HEAD: "Phó phòng",
  LEADER: "Trưởng nhóm",
  STAFF: "Nhân viên",
}

export const STAFF_ROLE_PROJECT_OPTIONS = [
  {
    title: STAFF_ROLE_PROJECT_TEXT.DEPARTMENT_HEAD,
    value: STAFF_ROLE_PROJECT.DEPARTMENT_HEAD,
    color: 'primary',
  },
  {
    title: STAFF_ROLE_PROJECT_TEXT.DEPUTY_HEAD,
    value: STAFF_ROLE_PROJECT.DEPUTY_HEAD,
    color: 'success',
  },
  {
    title: STAFF_ROLE_PROJECT_TEXT.LEADER,
    value: STAFF_ROLE_PROJECT.LEADER,
    color: 'info',
  },
  {
    title: STAFF_ROLE_PROJECT_TEXT.STAFF,
    value: STAFF_ROLE_PROJECT.STAFF,
    color: 'info',
  },
]


export const STAFF_ROLE_OPTIONS = [
  {
    title: STAFF_ROLE_TEXT.SUPERADMIN,
    value: STAFF_ROLES.SUPERADMIN,
    color: 'error',
  },
  {
    title: STAFF_ROLE_TEXT.DEPARTMENT_HEAD,
    value: STAFF_ROLES.DEPARTMENT_HEAD,
    color: 'primary',
  },
  {
    title: STAFF_ROLE_TEXT.STAFF,
    value: STAFF_ROLES.STAFF,
    color: 'info',
  },
  {
    title: STAFF_ROLE_TEXT.DEPUTY_HEAD,
    value: STAFF_ROLES.DEPUTY_HEAD,
    color: 'success',
  },
  {
    title: STAFF_ROLE_TEXT.DIRECTOR,
    value: STAFF_ROLES.DIRECTOR,
    color: 'warning',
  },
  {
    title: STAFF_ROLE_TEXT.PROFILE_MANAGER,
    value: STAFF_ROLES.PROFILE_MANAGER,
    color: 'warning',
  },
  {
    title: STAFF_ROLE_TEXT.INTERN,
    value: STAFF_ROLES.INTERN,
    color: 'info',
  },
]

export const STAFF_STATUSES = {
  READY: 1,
  BUSY: 2,
  TEMPORARILY_AWAY: 3,
  ON_LEAVE: 4,
}

export const STAFF_STATUS_TEXT = {
  READY: "Sẵn sàng",
  BUSY: "Bận",
  TEMPORARILY_AWAY: "Tạm vắng",
  ON_LEAVE: "Nghỉ phép",
}

export const STAFF_STATUS_OPTIONS = [
  {
    title: STAFF_STATUS_TEXT.READY,
    value: STAFF_STATUSES.READY,
  },
  {
    title: STAFF_STATUS_TEXT.BUSY,
    value: STAFF_STATUSES.BUSY,
  },
  {
    title: STAFF_STATUS_TEXT.TEMPORARILY_AWAY,
    value: STAFF_STATUSES.TEMPORARILY_AWAY,
  },
  {
    title: STAFF_STATUS_TEXT.ON_LEAVE,
    value: STAFF_STATUSES.ON_LEAVE,
  },
]


export const MEASURE_TEMPLATE_STATUS = {
  PENDING_SHEET_GENERATION: 0,
  AWAITING_DATA_MAPPING: 1,
  GENERATION_FAILED: 2,
  DATA_MAPPED: 3,
}

export const MEASURE_TEMPLATE_STATUS_TEXT = {
  PENDING_SHEET_GENERATION: "Đang chuẩn bị dữ liệu",
  AWAITING_DATA_MAPPING: "Đang xử lý",
  GENERATION_FAILED: "Lỗi xử lý",
  DATA_MAPPED: "Hoàn tất",
}

export const MEASURE_TEMPLATE_STATUS_OPTIONS = [
  {
    title: MEASURE_TEMPLATE_STATUS_TEXT.PENDING_SHEET_GENERATION,
    value: MEASURE_TEMPLATE_STATUS.PENDING_SHEET_GENERATION,
    color: 'secondary',
  },
  {
    title: MEASURE_TEMPLATE_STATUS_TEXT.AWAITING_DATA_MAPPING,
    value: MEASURE_TEMPLATE_STATUS.AWAITING_DATA_MAPPING,
    color: 'warning',
  },
  {
    title: MEASURE_TEMPLATE_STATUS_TEXT.GENERATION_FAILED,
    value: MEASURE_TEMPLATE_STATUS.GENERATION_FAILED,
    color: 'error',
  },
  {
    title: MEASURE_TEMPLATE_STATUS_TEXT.DATA_MAPPED,
    value: MEASURE_TEMPLATE_STATUS.DATA_MAPPED,
    color: 'success',
  },
]

// Review Status Constants
export const REVIEW_STATUSES = {
  IN_PROGRESS: 1,
  COMPLETED: 2,
}

export const REVIEW_STATUS_TEXT = {
  IN_PROGRESS: "Đang tiến hành",
  COMPLETED: "Đã kết thúc",
}

export const REVIEW_STATUS_OPTIONS = [
  {
    title: REVIEW_STATUS_TEXT.IN_PROGRESS,
    value: REVIEW_STATUSES.IN_PROGRESS,
  },
  {
    title: REVIEW_STATUS_TEXT.COMPLETED,
    value: REVIEW_STATUSES.COMPLETED,
  },
]

// Review Score Options - Clone từ VIMS cũ
export const REVIEW_SCORE_OPTIONS = [
  { value: '', title: '---' },   // Mặc định
  { value: 1, title: 'm' },      // Option 1
  { value: 2, title: 'M' },       // Option 2
]

// Table Headers cho màn chi tiết hậu kiểm
export const TABLE_HEADERS = {
  REVIEW_DETAIL: [
    { title: 'STT', key: 'stt', sortable: false, width: '60px', align: 'center' },
    { title: 'Vụ giám định', key: 'project_info', sortable: false, width: '14%', align: 'center' },
    { title: 'Ghi chú & Phản hồi', key: 'note', sortable: false, width: '32%', align: 'center' },
    { title: 'Đánh giá & Thống kê', key: 'review_score', sortable: false, width: '27%', align: 'center' },
    { title: 'Hoàn thành hậu kiểm', key: 'completion_status', sortable: false, width: '27%', align: 'center' },
  ],
}

export const MEASURE_METHOD_TYPE = {
  EXCEL: 1,
  APP: 2,
}

export const PROJECT_WORK_SESSION_ROOT = null

export const PRINT_TEMPLATE_PARAM_TYPE = {
  TYPE_TEXT_INPUT: 1,
  TYPE_SELECT_OPTION: 2,
  TYPE_STAFF_SIGNATURE: 3, // Chữ ký nhân viên

  TYPE_CUSTOMER_SIGNATURE: 4, // Chữ ký khách hàng
  TYPE_INDEX: 5, // Số thứ tự
  TYPE_STAFF_NAME: 6, // Tên nhân viên thự hiện số đo
  TYPE_GET_MEASURE_BY_ROUND_NAME: 95, // Lấy từ độ đo - tên lần đo
  TYPE_GET_MEASURE_BY_LABEL: 96, // Lấy từ độ đo - nhãn
  TYPE_GET_MEASURE_BY_VALUE: 97, // Lấy từ độ đo - giá trị tham số
  TYPE_GET_MEASURE_BY_FORMULA: 98, // Lấy từ độ đo - công thức
  TYPE_DATA_FUNCTION: 99, // Lấy từ cơ sở dữ liệu
  TYPE_GET_FROM_ACTION_STEP: 100, // Lấy từ bước thực hiện
  TYPE_GET_FROM_ACTION_STEP_RESULT: 101, // Lấy kết luận hành động
  TYPE_STAFF: 103, // chọn danh sách nhân sự
  TYPE_CERTIFICATE_SERIAL_NUMBER: 104, // chọn danh sách nhân sự
}

export const REQUEST_TYPE = {
  VIEW_PROJECT_PROFILE: 'view_project_profile',

}
